import React, { Fragment, useMemo } from 'react';
import { classSet } from '@umu/umu-dom';

import { lang, commonLang } from '@umu/ukit-lang';
import { ICertificateThemeProps } from '../../interface/common';
import { TrophyInfo, QrCodeContent, EditorInput } from '../../components/index';
import { defaultTrophyInfoConfig, COMMENT_MAX_LEN, getStudyTemplateQrCodeParams, DEFAULT_SCALE_RATIO, getCertificateIssueTime } from '../../dataflow/common';

import './index.scss';

const SystemStudyTheme1 = (props: ICertificateThemeProps) => {
    const { themeInfo, scaleRatio = DEFAULT_SCALE_RATIO} = props;
    const {
        trophyInfoConfig = defaultTrophyInfoConfig,
        traineesName,
        traineesSubName = '',
        certificateText,
        courseInfo,
        certificateDisplayConfig: conf,
    } = themeInfo;
    const renderTrophyInfo = useMemo(() => {
        const { isShow = false, isEnterprise, cls, viewType, trophyElement } = trophyInfoConfig;
        return isShow ? (
            <div className="theme-info1-trophy">
                <TrophyInfo
                    isEnterprise={!!isEnterprise}
                    className={cls}
                    isCustomTrophy={!!viewType}
                    customTrophy={trophyElement}
                />
            </div>
        ) : null;
    }, [trophyInfoConfig]);
    const renderContent = () => {
        return (
            <div className="theme-info-content theme-info1-content">
                <div className="theme-info-title text-row-1">{traineesName}</div>
                {!!conf.isShowTraineesSubName && !!traineesSubName && <div className="theme-info-sub-title">{traineesSubName}</div>}
                <div className={classSet({
                    'theme-info-desc truncate-text-2': true,
                    'theme-info-desc-weight': !!conf.isShowTraineesSubName && !!traineesSubName
                })}>
                    <EditorInput
                        className="editor-panel-comment-zone"
                        value={certificateText}
                        isAllowEditor={!!conf.isAllowEditor}
                        maxLength={COMMENT_MAX_LEN}
                        onChange={(val) => {
                            props.onConfigChange && props.onConfigChange('certificateText', val);
                        }}
                    />
                </div>
                <div className="theme-info-course truncate-text-2">{commonLang('《')}{courseInfo?.courseName}{commonLang('》')}</div>
            </div>
        );
    };

    const renderFooter = () => {
        const grantTs = Number(conf.setUpInfo?.certificateIssueTime || '0');
        return (
            <div className="theme-info-footer theme-info1-footer">
                <div>
                    <QrCodeContent
                        id="certificateId"
                        className="theme-info1-qr"
                        codeOptions={{
                            text: conf.setUpInfo ? conf.setUpInfo.QRCodeUrl : 'https://umu.cn',
                            ...getStudyTemplateQrCodeParams(scaleRatio)
                        }}
                    />
                </div>
                {conf.isShowLecturer && (<div className="theme-info-lecturer theme-info1-lecturer">
                <EditorInput
                    className="editor-panel-lecture-zone"
                    value={conf.setUpInfo?.lecturerName || ''} isAllowEditor={!!conf.isAllowEditor} onChange={(val) => {
                    props.onConfigChange && props.onConfigChange('lecturerName', val)
                }}>
                    {!!conf.setUpInfo && !!conf.setUpInfo?.lecturerName ? (
                        <Fragment>
                            <span>{conf.setUpInfo?.lecturerSubName || lang('课程讲师')}</span><span className="theme-split">:</span>
                        </Fragment>
                    ) : <></>}
                </EditorInput>
            </div>)}
                {conf.isShowCertificateIssueTime && (
                    <div className="theme-info-date theme-info1-date">
                        <span>{lang('日期')}</span>
                        <span className="theme-split">:</span>
                        <span>{getCertificateIssueTime(grantTs)}</span>
                    </div>
                )}
            </div>
        );
    };
    return (
        <div className="system-study-theme theme-info1">
            {renderTrophyInfo}
            {renderContent()}
            {renderFooter()}
        </div>
    );
};
export { SystemStudyTheme1 };
